import gql from 'graphql-tag';

const DELETE_HOMEOWNER_APPOINTMENT = gql` 
  mutation deleteHomeownerAppointment($input: HomeownerAppointmentDeleteInput!, $sendEmail: Boolean!) {
    deleteHomeownerAppointment(input: $input, sendEmail: $sendEmail) {
      message
      code
    }
  }
`;

export default DELETE_HOMEOWNER_APPOINTMENT;